import { type ReactNode } from 'react'
import classes from './PageBackground.module.scss'

interface PageBackgroundProps {
  children: ReactNode
}

export const PageBackground = ({ children }: PageBackgroundProps) => (
  <div className={classes.wrapper}>
    <svg
      className={classes.heroBlob}
      width='500'
      height='1289'
      viewBox='0 0 500 1289'
      fill='none'
      aria-hidden
    >
      <g filter='url(#prcng906_heroBlobBlur)'>
        <path
          d='M593.172 682.99C642.252 639.579 708.356 501.346 735.272 437.657L599.821 354.001L546 463.465L395.733 797.349C373.536 858.365 336.084 969.188 363.859 924.356C398.578 868.315 531.823 737.253 593.172 682.99Z'
          fill='#FF9BB7'
        />
      </g>
      <defs>
        <filter
          id='prcng906_heroBlobBlur'
          x='0'
          y='0'
          width='1089.27'
          height='1288.76'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feGaussianBlur stdDeviation='177' result='effect1_foregroundBlur' />
        </filter>
      </defs>
    </svg>
    <svg
      className={classes.sideBlob}
      width='363'
      height='1338'
      viewBox='0 0 363 1338'
      fill='none'
      aria-hidden
    >
      <g filter='url(#prcng906_sideBlobBlur)'>
        <path
          d='M-168.74 647.023C-216.35 707.804 -269.967 882.963 -290.823 962.944L-132.624 1033.18L-88.5634 894.169L30.729 473.01C46.8102 397.118 72.9043 259.86 48.6309 317.961C18.289 390.586 -109.227 571.046 -168.74 647.023Z'
          fill='#E60C49'
          fillOpacity='0.7'
        />
      </g>
      <defs>
        <filter
          id='prcng906_sideBlobBlur'
          x='-594.823'
          y='0'
          width='957.337'
          height='1337.18'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feGaussianBlur stdDeviation='152' result='effect1_foregroundBlur' />
        </filter>
      </defs>
    </svg>
    <div className={classes.ellipses} aria-hidden>
      <span />
      <span />
      <span />
    </div>
    <div className={classes.content}>{children}</div>
  </div>
)
